import asyncSeries from 'async/series';
import UserStore from './user_store';

export default {
  init,
};
function init(done: any) {
  asyncSeries([UserStore.init], done);
}
